import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 no-underline"
          >
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-book-read-line text-xl text-primary-500"></i>
            </div>
            <span className="font-heading text-xl text-foreground-900 whitespace-nowrap">
              韩漫在线阅读网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.slice(0, 6).map((cat) => (
              <Link
                key={cat.id}
                to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  (cat.slug === 'all' && location.pathname === '/') ||
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-600 bg-primary-100/70'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap"
            >
              关于我们
            </Link>
            <Link
              to="/"
              className="px-4 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              开始阅读
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl text-foreground-900 ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 py-3 px-2">
            <div className="flex flex-wrap gap-1 mb-3">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
                  className={`px-3 py-1.5 rounded-full text-sm transition-colors whitespace-nowrap ${
                    (cat.slug === 'all' && location.pathname === '/') ||
                    location.pathname === `/category/${cat.slug}`
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>
            <div className="flex items-center gap-3 pt-2 border-t border-background-200/70">
              <Link
                to="/about"
                className="text-sm text-foreground-600 hover:text-foreground-900 whitespace-nowrap"
              >
                关于我们
              </Link>
              <Link
                to="/"
                className="px-4 py-1.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap"
              >
                开始阅读
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}